import { useState, useEffect } from 'react'

import cn from 'classnames'
import { Link } from 'react-router-dom'

import mainVideo from '@/assets/main.mp4'
import videoPoster from '@/assets/thumb/5.png'
import { Video } from '@/components/Video'

import { HeroProps } from './Hero.types'

const roles = ['Auditors', 'Financial Reporters', 'Accountants']

export const Hero = (props: HeroProps) => {
    const { className } = props

    const [currentRoleIndex, setCurrentRoleIndex] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentRoleIndex((prev) => (prev + 1) % roles.length)
        }, 3000)

        return () => { clearInterval(interval) }
    }, [])

    return (
        <section className={cn('bg-gradient-to-b from-gray-50 to-white', className)}>
            <div className='px-4 py-20 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-28 w-full'>
                <div className='flex flex-col items-center justify-between lg:flex-row lg:items-center'>
                    <div className='mb-10 w-full text-center lg:text-left lg:max-w-lg lg:pr-5 lg:mb-0'>
                        <div className='max-w-xl mb-6 mx-auto lg:mx-0'>
                            <div>
                                <p className='inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-primary uppercase rounded-full bg-primary/10'>
                                    Automated Review
                                </p>
                            </div>
                            <h1 className='max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none'>
                                Automating financial statement review for
                                <br className='hidden md:block'/>
                                <span className='inline-block text-primary'>{roles[currentRoleIndex]}</span>
                            </h1>
                            <p className='text-base text-gray-700 md:text-lg'>
                                Enhance compliance with financial reporting standards and applicable laws. Reduce manual review tasks up to 90% with intelligent automation.
                            </p>
                        </div>
                        <div className='flex flex-col items-center md:flex-row md:justify-center lg:justify-start'>
                            <Link to='/contacts' className='inline-flex items-center justify-center w-full md:w-auto h-12 px-6 mb-3 font-medium tracking-wide text-white transition duration-200 rounded shadow-md md:mr-4 md:mb-0 bg-primary hover:bg-primary-hover focus:shadow-outline focus:outline-none'>
                                <span className='mr-3'>Contact us</span>
                            </Link>
                            <a href='#features' aria-label='' className='inline-flex items-center font-semibold text-gray-800 transition-colors duration-200 hover:text-primary'>
                                Learn more
                            </a>
                        </div>
                    </div>
                    <div className='relative w-full lg:w-1/2 mt-8 lg:mt-0'>
                        <Video
                            src={mainVideo}
                            poster={videoPoster}
                            title='Hero video'
                            className='rounded-lg shadow-lg'
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
